// src/redux/slices/resourcesSlice.ts

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getResourceDetailsApi,
  ResourceDetails,
} from "../../apis/resourcesApis";

/* =====================================================
   STATE
===================================================== */

interface ResourcesState {
  resourceDetails: ResourceDetails | null;
  loading: boolean;
  error: string | null;
}

const initialState: ResourcesState = {
  resourceDetails: null,
  loading: false,
  error: null,
};

/* =====================================================
   THUNK
===================================================== */

export const fetchResourceDetails = createAsyncThunk(
  "resources/fetchResourceDetails",
  async (resourceId: string, { rejectWithValue }) => {
    try {
      const response = await getResourceDetailsApi(resourceId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.data || "Failed to fetch resource details",
      );
    }
  },
);

/* =====================================================
   SLICE
===================================================== */

const resourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    clearResourceDetails: (state) => {
      state.resourceDetails = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResourceDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResourceDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.resourceDetails = action.payload;
      })
      .addCase(fetchResourceDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearResourceDetails } = resourcesSlice.actions;
export default resourcesSlice.reducer;
